import React from 'react'
import styled from 'styled-components'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import therapyImage from '../assets/therapy-session-two-women.svg'
import peopleGarden from '../assets/tiny-people-beautiful-flower-garden-inside.svg'
import mentalHealthPsicoterapia from '../assets/mental-health-psicoterapia.svg'
import OpacityAnimation from '../components/OpacityAnimation'


const PsicotherapyPage = () => {


  return (
    <Wrapper>
        <OpacityAnimation>
            <MDBContainer>
                <MDBRow className="pt-4">
                    <h3 className="font-weight-bold">Abordagem - Psicoterapia Psicanalítica</h3>
                    <hr />
                    <MDBCol md="12" lg="5" className="my-4">
                        <p>O processo psicoterapêutico promove mudanças na vida do paciente com vista a aumentar o seu bem-estar e equilíbrio psicológico. A psicoterapia viabiliza uma evolução para uma vida mais gratificante, mais livre, mais autêntica, mais criativa, mais autónoma e mais plena.</p>
                        <p>Trata-se de ajudar os pacientes a aliviarem o seu sofrimento interno, numa experiência única de aprendizagem, mudança e crescimento pessoal. </p>
                        <p>É um trabalho de coconstrução de novos significados e sentidos, em que se verifica uma primazia da comunicação como veículo do tratamento.</p>
                    </MDBCol>
                    <MDBCol md="12" lg="7" className="my-4">
                      <img src={therapyImage} alt="therapy with two women" className="img-fluid" />
                    </MDBCol>
                    <MDBCol sm="12" className="my-2">
                        <p>Tal ocorre num ambiente seguro, confidencial, em que a relação terapêutica está no centro da terapia e em que o terapeuta é o agente facilitador da transformação, daquilo que o sujeito é para aquilo que ele gostaria de ser.</p>
                        <p>Na experiência psicoterapêutica, o paciente vai adquirindo uma maior capacidade de pensar sobre a sua realidade, de elaborá-la e transformá-la. A psicoterapia o auxilia na superação e compreensão dos seus conflitos internos, melhora a sua gestão das emoções, os seus padrões relacionais disfuncionais e fomenta o desenvolvimento pessoal e o autoconhecimento.</p>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol sm="12" lg="7" className="my-4">
                      <img src={peopleGarden} alt="therapy with two women" className="img-fluid" />
                    </MDBCol>
                    <MDBCol sm="12" lg="5" className="my-4">
                        <p>A psicoterapia é, no fundo, um encontro consigo mesmo, a mais profunda experiência de si. É um estudo da subjetividade em intersubjetividade, é um encontro relacional e experiencial onde é possível repensar e reestruturar certas fases de desenvolvimento que ficaram suspensas ou incompletas, reparar vicissitudes relacionais, criar novos recursos e valorizar potencialidades, reconstruir o amor-próprio, através de novas experiências emocionais e de uma relação sanígena. </p>
                        <p>O maior bem-estar proporcionado pela realização de uma psicoterapia pessoal irá refletir-se numa maior qualidade de vida, reforço da autoestima, liberdade e flexibilidade para enfrentar futuros desafios e viver a vida na sua plenitude. </p>
                    </MDBCol>
                </MDBRow>
                <MDBRow> 
                    <MDBCol sm="12" lg="6" className="my-4">  
                        <p>Vamos crescendo a partir do encontro com o outro; o mundo interno / a vida mental do sujeito organiza-se e constrói-se nas suas relações, as quais vão sendo interiorizadas de forma implícita, inconsciente e modelam posteriores atitudes, relações, reações, interpretações e perceções, sob forma de padrões por vezes rígidos e repetitivos. Na psicoterapia, cria-se um espaço onde é possível reorganizar estas dinâmicas relacionais quando estas são disfuncionais.</p>
                    </MDBCol>
                    <MDBCol sm="12" lg="6" className="mt-4">
                      <img src={mentalHealthPsicoterapia} alt="therapy with two women" className="img-fluid" />
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </OpacityAnimation>
    </Wrapper>
  )
}

const Wrapper = styled.section`
      background: var(--website-psycotherapy-bg-color);
      margin-top: 8rem;
      margin-bottom: 8rem;
`

export default PsicotherapyPage
